// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d42e8e3","453":"05343f66","455":"c79f0e4e","977":"e75aa33d"}[chunkId] + ".chunk.js";
};